import dynamic from "next/dynamic";
import Loading from "@/components/common/Loading";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";
import MobileSpaAndSalon from "@/components/industries/SpaAndSalon/MobileSpaAndSalon";
import SpaAndSalon from "@/components/industries/SpaAndSalon/SpaAndSalon";


const SpaSalon = ({ mobileView }) => {
   return (
      <>
         <Head>
            <title>Spa & Salon Management Software for Billing and Bookings</title>
            <meta name="description" content="Streamline spa & salon operations with our software. Seamlessly manage billing, appointments, and bookings. Experience a free demo and elevate customer today." />
            <link rel="canonical" href="https://queuebuster.co/Industries/spa-and-salon-pos-billing-software" />
            <link rel="alternate" href="https://queuebuster.co/Industries/spa-and-salon-pos-billing-software" hrefLang="en" />
            <meta property="og:title" content="India's No.1 POS Billing Software for Spa & Salon & Beauty Parlour - Get a Free Demo" />
            <meta property="og:description" content="Discover India's No.1 POS Billing Software for Spa, Salon, and Beauty Parlours - Effortlessly manage appointments, billing, inventory, and more! Download the QueueBuster POS app and start your free experience with us." />
            <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/og-spasalon.jpg" />
            <meta property="og:url" content="https://queuebuster.co/Industries/spa-and-salon-pos-billing-software" />
            
         </Head>
         <SchemaTags page="spa-and-salon-pos-billing-software" />
         {mobileView ? <MobileSpaAndSalon /> : <SpaAndSalon />}
      </>
   );
};

export default SpaSalon;
